var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 43,
    viewBox: "0,0,238.13281,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 16.6334,
    y1: 32.4954,
    x2: 32.503,
    y2: 2.90338,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3290ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c5286"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.34369,209.63713) rotate(164) scale(5.95349,5.95349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,35c8.2843,0 15,-6.7157 15,-15c0,-8.2843 -6.7157,-15 -15,-15c-8.2843,0 -15,6.7157 -15,15c0,8.2843 6.7157,15 15,15z",
    fill: "none",
    strokeOpacity: 0.2,
    stroke: "#054d94",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,35c8.2843,0 15,-6.7157 15,-15c0,-8.2843 -6.7157,-15 -15,-15c-8.2843,0 -15,6.7157 -15,15c0,8.2843 6.7157,15 15,15z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.6334,32.4954l-1.268,-24.49542l5.7825,8.82052l9.4844,-4.033z",
    fill: "url(#color-1)",
    stroke: "none",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.36a075fb35a6df305538192b1d9d89a9.svg";
export { ForwardRef as ReactComponent };